export default __webpack_public_path__ + "static/media/1mm_bag.e74593ca.jpg";